import { FC, ReactElement } from "react"
import { Controller, ControllerRenderProps, UseFormReturn } from "react-hook-form"

type ControllerGroupProps = {
  form?: UseFormReturn<any, any>,
  names: string[],
  render: ({ fields }: { fields: ControllerRenderProps<any, any>[] }) => ReactElement
}

const ControllerGroup: FC<ControllerGroupProps> = ({ form, render, names }) => {
  if (!names.length || !form?.control) {
    return render({ fields: [] })
  }

  const renderController = ({ fieldNames, fields }: { fieldNames: string[], fields: ControllerRenderProps<any, any>[] }) => {
    const [firstFieldName, ...nestedFieldNames] = [...fieldNames]
    if (!firstFieldName) {
      return render({ fields })
    }
    return (
      <Controller
        control={form?.control}
        name={firstFieldName}
        render={({ field }) => {
          if (nestedFieldNames.length > 0) {
            return renderController({ fieldNames: nestedFieldNames, fields: [field, ...fields] })
          }
          return render({ fields: [field, ...fields] })
        }}
      />
    )
  }
  return (
    <>
      {renderController({ fieldNames: names, fields: [] })}
    </>
  )
}

ControllerGroup.displayName = 'ControllerGroup'

export default ControllerGroup